import { LoadingAnimation, Select } from '@uag/react-core';
import { useGetContributors } from '@uag/welcome-shared/src/api/queries/contributors/contributors';
import { useTranslation } from 'react-i18next';

import { getContributorOption, renderContributorOption } from './ContributorSelectOption';

type Props = {
    value: string | null | undefined;
    onChange: (value: string | undefined) => void;
};

export const ResponsiblePersonCombobox = ({ value, onChange: handleOnChange }: Props) => {
    const { t } = useTranslation();
    const { data: apiContributors, isLoading: areContributorsLoading } = useGetContributors();
    const contributors = apiContributors?.data?.map(getContributorOption) ?? [];

    if (areContributorsLoading) {
        return (
            <div className="p-base">
                <LoadingAnimation />
            </div>
        );
    }
    return (
        <Select
            classNames={{
                option: 'p-0',
            }}
            data={[...contributors]}
            label={t('responsiblePerson')}
            renderOption={renderContributorOption}
            value={value}
            allowDeselect
            clearable
            searchable
            onChange={(value) => handleOnChange(value ? value : undefined)}
        />
    );
};
